import { Grid } from "@material-ui/core";
import { useCallback, useEffect } from "react";
import { AutocompleteInput, ReferenceInput, TextInput, useDataProvider } from "react-admin";
import { useForm } from "react-final-form";
import { mytvsuperUrl } from "../../../constant";

var programmePath = "";

export const EpisodeSearch = (props) => {
  const formData = props.formData;
  const rest = props.rest;

  // reset the form into initial values
  const form = useForm();
  const dataProvider = useDataProvider();

  // check change of programme_id , fetch programme name , fill the field
  useEffect(async () => {
    if (formData.programme_id) {
      const result = await dataProvider.getProgrammeByProgrammeId(parseInt(formData.programme_id));

      if (result && result.data && result.data.name_tc) {
        form.change("programme_name", result.data.name_tc);

        // Auto complete "destination_url"
        programmePath = result.data.path;
        form.change("destination_url", mytvsuperUrl + "/tc/programme/" + programmePath + "/");
      }
    }
  }, [formData.programme_id]);

  useEffect(async () => {
    if (formData.episode_id_for_url) {
      // Auto complete "destination_url"
      form.change("destination_url", mytvsuperUrl + "/tc/programme/" + programmePath + "/e/" + formData.episode_id_for_url + "/");
    }
  }, [formData.episode_id_for_url]);

  const fetchProgramme = useCallback(async (filterType) => {
    const result = await dataProvider.getProgrammeByProgrammeId(filterType);

    form.change("title_tc", result.data.name_tc);
    form.change("title_en", result.data.name_en);
  });

  const fetchEpisode = useCallback(async () => {
    const formValues = form.getState().values;

    form.change("episode_id_for_url", formValues.episode_autocomplete);
  });

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={4}>
        <AutoCompleteProgramme clearAlwaysVisible={true} fullWidth formData={formData} {...rest} allowEmpty={true} fetchProgramme={fetchProgramme} />
      </Grid>

      <Grid item sm={12} md={4}>
        <AutoCompleteEpisode clearAlwaysVisible={true} fullWidth formData={formData} {...rest} allowEmpty={true} fetchEpisode={fetchEpisode} />
      </Grid>

      <Grid item sm={12} md={4}>
        <TextInput label="Content ID" source="programme_id" disabled fullWidth />
      </Grid>

      {/* <Grid item sm={12} md={6}>
        <TextInput label="Episode ID" source="episode_id_for_url" disabled fullWidth />
      </Grid> */}

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in TC *" source="title_tc" disabled fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in EN *" source="title_en" disabled fullWidth />
        </Grid>
      </Grid>
    </Grid>
  );
};

const AutoCompleteProgramme = (props) => {
  const form = useForm();

  useEffect(() => {});

  return (
    <ReferenceInput
      label="Search Programme Name"
      source="programme_autocomplete"
      reference="programmes-autocomplete"
      onChange={(val) => {
        props.fetchProgramme(val);

        form.change("programme_id", val);
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="programme_id" fullWidth />
    </ReferenceInput>
  );
};

const AutoCompleteEpisode = (props) => {
  const form = useForm();

  useEffect(() => {});

  return (
    <ReferenceInput
      label="Episode"
      source="episode_autocomplete"
      reference="episodes-autocomplete"
      perPage={9999999}
      onChange={(val) => {
        props.fetchEpisode(val);

        form.change("episode_no", val);
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return {
            programme_id: form.getState().values.programme_id,
            episode_no: searchText,
          };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="id" translateChoice={false} fullWidth />
    </ReferenceInput>
  );
};
